// extracted by mini-css-extract-plugin
export var wrapper = "MainSlider-module--wrapper--15N5s";
export var slickDots = "MainSlider-module--slick-dots--NXKxv";
export var sliderItemInner = "MainSlider-module--slider-item-inner--T2-ba";
export var sliderItem = "MainSlider-module--slider-item--WWWBg";
export var text = "MainSlider-module--text--11ROq";
export var image = "MainSlider-module--image--2jxps";